module.exports = __webpack_public_path__ + "static/img/pico34.4950ae0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico34.png
// module id = WQCk
// module chunks = 0